export default function parseAreaGuideTitle(areaGuideTitle: string): string {
  const LIVING_IN_REGEX = /living in/i;

  return areaGuideTitle.replace(LIVING_IN_REGEX, 'Moving To');
}
